// src/admin/pages/AdminCustomerProfile.js
import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaUserSlash,
  FaUserShield,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";
import { FaInbox } from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";
import {
  getAdminCustomerById,
  toggleAdminCustomerStatus,
  updateAdminCustomer,
  updateAdminCustomerAddress,
  resetAdminCustomerPassword,
} from "../../services/adminCustomers.api";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { FaEdit, FaTrash } from "react-icons/fa";
import { deleteAdminCustomer } from "../../services/adminCustomers.api";
import { adminApiRequest } from "../../services/adminApi";
import { FaShoppingCart, FaStore } from "react-icons/fa";
import { FaWhatsapp, FaInstagram } from "react-icons/fa";

function AdminCustomerProfile() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const [editing, setEditing] = useState(false);

  const [deleteId, setDeleteId] = useState(null);

  
  const [actionsOpen, setActionsOpen] = useState(false);

  const [errors, setErrors] = useState({});

  const [lastOrderDetails, setLastOrderDetails] = useState(null);

  const [isDirty, setIsDirty] = useState(false);

  const [showConfirmSave, setShowConfirmSave] = useState(false);
const [toast, setToast] = useState(null);
const [isSaving, setIsSaving] = useState(false);
const [resetPasswordOpen, setResetPasswordOpen] = useState(false);
const [newPassword, setNewPassword] = useState("");
const [showResetPassword, setShowResetPassword] = useState(false);
const [form, setForm] = useState({
  name: "",
  phone: "",
  email: "",
  country: "Lebanon",
  city: "",
  area: "",
  street: "",
  building: "",
  businessName: "",
  instagramName: "",
  instagramLink: "",
  wholesaleRequestId: "",
});

  const { lang } = useContext(AdminLanguageContext);

  const TEXT = {
  EN: {
    title: "Customer",
    stats: "Stats",
    contactInfo: "Contact information",
    defaultAddress: "Default address",
    joined: "Joined",
    lastLogin: "Last login",
    totalSpent: "Total spent",
    orders: "Orders",
country: "Country",
    block: "Block",
    unblock: "Unblock",
    address: "Address",
    orderHistory: "Order history",
    orderId: "Order",
    date: "Date",
    onlineStore: "Online Store",
    total: "Total",
    status: "Status",
    loading: "Loading customer...",
    at: "at",
from: "from",
    empty: "—",
wholesaleInfo: "Wholesale information",
businessName: "Business name",
instagramName: "Instagram username",
instagramLink: "Instagram account link",
openInstagram: "Open Instagram",
     actions: "More actions",
  marketing: "Marketing",
  lastOrderPlaced: "Last order placed",
  viewAllOrders: "View all orders",
  createOrder: "Create order",
  noOrders: "No orders yet",
  emailLabel: "Email",
whatsappLabel: "WhatsApp",
resetPassword: "Reset password",
newPassword: "New password",
passwordRequired: "Password is required",
passwordResetSuccess: "Password reset successfully",
    // ✅ NEW
    edit: "Edit",
    cancel: "Cancel",
    save: "Save",
    discard: "Discard",
    governorate: "Governorate",
    area: "Area",
    street: "Street",
    building: "Building",
    placedOrder: "placed an order",
    editingCustomer: "Editing customer",
    selectGovernorate: "Select Governorate",
  },

  AR: {
    title: "العميل",
    stats: "الإحصائيات",
    onlineStore: "المتجر الإلكتروني",
    contactInfo: "معلومات التواصل",
    defaultAddress: "العنوان الافتراضي",
    joined: "تاريخ التسجيل",
    lastLogin: "آخر تسجيل دخول",
    placedOrder: "قام بإنشاء طلب",
    at: "في",
country: "الدولة",
from: "من",
    totalSpent: "إجمالي الإنفاق",
    emailLabel: "البريد الإلكتروني",
whatsappLabel: "واتساب",
    orders: "الطلبات",
    block: "حظر",
    unblock: "إلغاء الحظر",
    address: "العنوان",
    orderHistory: "سجل الطلبات",
    orderId: "الطلب",
    date: "التاريخ",
    total: "الإجمالي",
    status: "الحالة",
    loading: "جاري تحميل العميل...",
    empty: "—",
     actions: "إجراءات",
  marketing: "التسويق",
  lastOrderPlaced: "آخر طلب تم",
  viewAllOrders: "عرض كل الطلبات",
  createOrder: "إنشاء طلب",
  noOrders: "لا يوجد طلبات",
resetPassword: "إعادة تعيين كلمة المرور",
newPassword: "كلمة المرور الجديدة",
passwordRequired: "كلمة المرور مطلوبة",
passwordResetSuccess: "تم تغيير كلمة المرور بنجاح",
  wholesaleInfo: "معلومات الجملة",
businessName: "اسم العمل",
instagramName: "اسم مستخدم الإنستغرام",
instagramLink: "رابط حساب الإنستغرام",
openInstagram: "فتح الإنستغرام",
    edit: "تعديل",
    cancel: "إلغاء",
    save: "حفظ",
    discard: "تجاهل",
    governorate: "المحافظة",
    area: "المنطقة",
    street: "الشارع",
    building: "المبنى",
    editingCustomer: "تعديل بيانات العميل",
    selectGovernorate: "اختر المحافظة",
  },
}[lang];

  const LEBANON_GOVERNORATES = {
  EN: ["Beirut","Mount Lebanon","North","South","Bekaa","Nabatieh","Akkar","Baalbek-Hermel"],
  AR: ["بيروت","جبل لبنان","الشمال","الجنوب","البقاع","النبطية","عكار","بعلبك الهرمل"]
}[lang];

useEffect(() => {
  if (!customer?.orders?.length) return;

  const lastOrderId = customer.orders[0].id;

  adminApiRequest(`/admin/orders/${lastOrderId}`)
    .then(setLastOrderDetails)
    .catch(() => setLastOrderDetails(null));

}, [customer]);

useEffect(() => {
  const handleClick = (e) => {
    if (
      !e.target.closest(".actions-overlay") &&
      !e.target.closest(".actions-button")
    ) {
      setActionsOpen(false);
    }
  };

  if (actionsOpen) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [actionsOpen]);

useEffect(() => {
  if (!customer) return;

  const parts = (customer.address || "").split(" — ");

  const original = {
  name: customer.name || "",
  phone: customer.phone || "",
  email: customer.email || "",
country: customer.addressCountry || "Lebanon",
  city: parts[0] || "",
  area: parts[1] || "",
  street: parts[2] || "",
  building: parts[3] || "",
  businessName: customer.wholesaleInfo?.businessName || "",
  instagramName: customer.wholesaleInfo?.instagramName || "",
  instagramLink: customer.wholesaleInfo?.instagramLink || "",
  wholesaleRequestId: customer.wholesaleInfo?.wholesaleRequestId || "",
};

  const current = {
  name: form.name || "",
  phone: form.phone || "",
  email: form.email || "",
country: form.country || "Lebanon",
  city: form.city || "",
  area: form.area || "",
  street: form.street || "",
  building: form.building || "",
  businessName: form.businessName || "",
  instagramName: form.instagramName || "",
  instagramLink: form.instagramLink || "",
  wholesaleRequestId: form.wholesaleRequestId || "",
};

  const changed = Object.keys(original).some(
    (key) => String(original[key]).trim() !== String(current[key]).trim()
  );

  setIsDirty(changed);
}, [form, customer]);

  useEffect(() => {
  if (customer) {
    const parts = (customer.address || "").split(" — ");

setForm({
  name: customer.name || "",
  phone: customer.phone || "",
  email: customer.email || "",
  country: customer.addressCountry || "Lebanon",
  city: parts[0] || "",
  area: parts[1] || "",
  street: parts[2] || "",
  building: parts[3] || "",
  businessName: customer.wholesaleInfo?.businessName || "",
  instagramName: customer.wholesaleInfo?.instagramName || "",
  instagramLink: customer.wholesaleInfo?.instagramLink || "",
  wholesaleRequestId: customer.wholesaleInfo?.wholesaleRequestId || "",
});
  }
}, [customer]);

  useEffect(() => {
    setLoading(true);
    getAdminCustomerById(id)
      .then(setCustomer)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [id]);

  const validate = () => {
  const errs = {};

  if (!form.name.trim()) {
    errs.name = lang === "AR" ? "الاسم مطلوب" : "Name is required";
  }

  if (!form.phone.trim()) {
    errs.phone = lang === "AR" ? "الرقم مطلوب" : "Phone required";
  }

  setErrors(errs);
  return Object.keys(errs).length === 0;
};

  const formatDateTime = (date) => {
  if (!date || date === "—") return TEXT.empty;

  return new Date(date).toLocaleString(lang === "AR" ? "ar-LB" : "en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const addressParts = (customer?.address || "").split(" — ");

const addressData = {
  governorate: addressParts[0] || "",
  area: addressParts[1] || "",
  street: addressParts[2] || "",
  building: addressParts[3] || "",
};

const normalizeInstagramLink = (value) => {
  const v = String(value || "").trim();

  if (!v) return "";

  if (v.startsWith("http://") || v.startsWith("https://")) {
    return v;
  }

  if (v.startsWith("@")) {
    return `https://instagram.com/${v.slice(1)}`;
  }

  return `https://instagram.com/${v}`;
};

const wholesaleInfo = customer?.wholesaleInfo || {};

const hasWholesaleInfo =
  wholesaleInfo.businessName ||
  wholesaleInfo.instagramName ||
  wholesaleInfo.instagramLink;

const wholesaleInstagramUrl = normalizeInstagramLink(
  wholesaleInfo.instagramLink || wholesaleInfo.instagramName
);

const formatCurrency = (value) => {
  return lang === "AR"
    ? `${value}$`
    : `$${value}`;
};

const formatPhone = (value) => value;

const getOrderSourceLabel = (source, lang) => {
  if (!source) {
    return lang === "AR" ? "على الموقع" : "on the website";
  }

  const s = source.toLowerCase();

  if (lang === "AR") {
    if (s === "store") return "في المتجر";
    if (s === "whatsapp") return "عبر واتساب";
    return "على الموقع";
  } else {
    if (s === "store") return "in store";
    if (s === "whatsapp") return "via WhatsApp";
    return "on the website";
  }
};

const getOrderSourceIcon = (source) => {
  const s = (source || "").toLowerCase();

  if (s === "store") {
    return <FaStore className="text-[11px] text-gray-500" />;
  }

  if (s === "whatsapp") {
    return <FaWhatsapp className="text-[11px] text-green-600" />;
  }

  return <FaShoppingCart className="text-[11px] text-gray-500" />;
};

const getOrderSourceBadge = (source) => {
  const s = (source || "").toLowerCase();

  if (s === "store") {
    return "bg-gray-100 text-gray-600 border-gray-200";
  }

  if (s === "whatsapp") {
    return "bg-green-50 text-green-700 border-green-200";
  }

  return "bg-gray-100 text-gray-600 border-gray-200";
};

const getStatusBadge = (status) => {
  const s = (status || "").toLowerCase();

  if (s === "paid" || s === "completed") {
    return "bg-green-100 text-green-800";
  }

  if (s === "pending") {
    return "bg-yellow-100 text-yellow-800";
  }

  if (s === "cancelled") {
    return "bg-red-100 text-red-800";
  }

  if (s === "processing") {
    return "bg-blue-100 text-blue-800";
  }

  return "bg-gray-200 text-gray-800";
};

const handleSave = async () => {
  if (!validate()) return;

  setIsSaving(true);

  try {
    await updateAdminCustomer(customer.id, {
      name: form.name,
      phone: form.phone,
      email: form.email,
    });

await updateAdminCustomerAddress(customer.id, {
  country: form.country,
  city: form.city,
  area: form.area,
  street: form.street,
  building: form.building,
  businessName: form.businessName,
  instagramName: form.instagramName,
  instagramLink: form.instagramLink,
  wholesaleRequestId: form.wholesaleRequestId,
});

    const updated = await getAdminCustomerById(customer.id);
    setCustomer(updated);

    setEditing(false);
    setIsDirty(false);
    setShowConfirmSave(false);
    setToast({
  type: "success",
  message: lang === "AR"
    ? "تم تحديث العميل"
    : "Customer updated"
});

setTimeout(() => {
  setToast(null);
  navigate("/admin/customers");
}, 1200);
  } catch (err) {
    console.error(err);
    alert(lang === "AR" ? "فشل حفظ التعديلات" : "Failed to save changes");
  } finally {
    setIsSaving(false);
  }
};

const handleResetPassword = async () => {
  if (!newPassword.trim()) {
    alert(TEXT.passwordRequired);
    return;
  }

  setIsSaving(true);

  try {
    await resetAdminCustomerPassword(customer.id, newPassword);

    setResetPasswordOpen(false);
setNewPassword("");
setShowResetPassword(false);

    setToast({
      type: "success",
      message: TEXT.passwordResetSuccess,
    });

    setTimeout(() => setToast(null), 2500);
  } catch (err) {
    alert(err.message);
  } finally {
    setIsSaving(false);
  }
};

const confirmDelete = async () => {
  try {
    await deleteAdminCustomer(deleteId);

    setToast({
  type: "success",
  message: lang === "AR" ? "تم حذف العميل" : "Customer deleted"
});

    setTimeout(() => {
      navigate("/admin/customers");
    }, 1000);

  } catch (e) {
    alert(e.message);
  } finally {
    setDeleteId(null);
  }
};

const formatSince = (date) => {
  if (!date) return "—";

  const now = new Date();
  const past = new Date(date);
  const diff = now - past;

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (years > 0) return `${lang === "AR" ? "منذ" : "since"} ${years} ${years > 1 ? "years" : "year"}`;
  if (months > 0) return `${lang === "AR" ? "منذ" : "since"} ${months} ${months > 1 ? "months" : "month"}`;
  if (weeks > 0) return `${lang === "AR" ? "منذ" : "since"} ${weeks} ${weeks > 1 ? "weeks" : "week"}`;
  return `${lang === "AR" ? "منذ" : "since"} ${days} ${days > 1 ? "days" : "day"}`;
};

 const toggleStatus = async () => {
  await toggleAdminCustomerStatus(customer.id);

  const newStatus = customer.status === "active" ? "blocked" : "active";

  setCustomer((c) => ({
    ...c,
    status: newStatus,
  }));

  setToast({
    type: "success",
    message:
      lang === "AR"
        ? newStatus === "active"
          ? "تم تفعيل العميل"
          : "تم حظر العميل"
        : newStatus === "active"
        ? "Customer activated"
        : "Customer blocked",
  });

  setTimeout(() => setToast(null), 2500);
};

 if (loading || !customer) {
  return (
    <div className="flex bg-[#f1f1f1] min-h-screen">
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className={`flex-1 ${lang === "EN" ? "lg:ml-64" : ""}`}>
        <AdminHeader setIsOpen={setIsOpen} />

        <main className="p-4 animate-pulse">
          <div className="max-w-[1040px] mx-auto space-y-4">

            {/* HEADER */}
            <div className="h-6 bg-gray-200 rounded w-1/3"></div>

            {/* STATS */}
            <div className="grid grid-cols-3 gap-3">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="h-16 bg-gray-200 rounded"></div>
              ))}
            </div>

            {/* CARDS */}
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-3">
              <div className="h-40 bg-gray-200 rounded"></div>
              <div className="h-40 bg-gray-200 rounded"></div>
            </div>

            {/* TIMELINE */}
            <div className="space-y-3">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="h-4 bg-gray-200 rounded w-2/3"></div>
              ))}
            </div>

          </div>
        </main>
      </div>
    </div>
  );
}

  return (
    <div className="flex bg-[#f1f1f1] min-h-screen">
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className={`flex-1 ${lang === "EN" ? "lg:ml-64" : ""}`}>
        <AdminHeader
  setIsOpen={setIsOpen}
  customCenter={
    <div
      className={`
        hidden sm:block w-full max-w-[500px]
        transition-all duration-300
        ${editing ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"}
      `}
    >
      <div className="bg-[#2c2c2c] border border-[#3a3a3a] rounded-md px-3 py-2 flex items-center justify-between">

        <div className="flex items-center gap-2 text-[13px] text-gray-200">
          <span>⚠️</span>
          <span>
            {lang === "AR" ? "تغييرات غير محفوظة" : "Unsaved changes"}
          </span>
        </div>

        <div className="flex gap-2">
          <button
            onClick={() => {
              setEditing(false);
              const parts = (customer.address || "").split(" — ");

setForm({
  name: customer.name || "",
  phone: customer.phone || "",
  email: customer.email || "",
  country: customer.addressCountry || "Lebanon",
  city: parts[0] || "",
  area: parts[1] || "",
  street: parts[2] || "",
  building: parts[3] || "",
  businessName: customer.wholesaleInfo?.businessName || "",
  instagramName: customer.wholesaleInfo?.instagramName || "",
  instagramLink: customer.wholesaleInfo?.instagramLink || "",
  wholesaleRequestId: customer.wholesaleInfo?.wholesaleRequestId || "",
});
            }}
            className="px-2 py-[2px] text-[12px] border rounded bg-[#1f1f1f] text-gray-200"
          >
            {lang === "AR" ? "إلغاء" : "Discard"}
          </button>

          <button
            onClick={() => setShowConfirmSave(true)}
            className="px-2 py-[2px] text-[12px] bg-white text-black rounded"
          >
            {lang === "AR" ? "حفظ" : "Save"}
          </button>
        </div>

      </div>
    </div>
  }
/>

        <main className="p-3 sm:p-5">

          <div className="max-w-[1040px] mx-auto">

            {/* HEADER (Shopify style like OrderDetails) */}
            <div className="flex items-center justify-between mb-4">

              <div className="flex items-center gap-2">

                <button
                  onClick={() => navigate(-1)}
                  className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-200"
                >
                  <FaUser className="text-gray-900 text-[18px]" />
                </button>

                <div className="flex items-center gap-2">
                  <FiChevronRight className="text-gray-400" />
                  <h1 className="text-[17px] font-semibold text-gray-900">
                    {customer.name || TEXT.title}
                  </h1>
                </div>
              </div>

<div className="relative">

<button
  onClick={() => setActionsOpen(v => !v)}
  className="
    actions-button
    flex items-center gap-1
    h-8 px-3
    bg-[#f6f6f7]
    border border-gray-300
    rounded-lg
    shadow-[0_1px_0_rgba(0,0,0,0.04),0_2px_5px_rgba(0,0,0,0.06)]
    text-sm font-medium text-gray-900
    hover:bg-gray-100
    transition
  "
>
  {TEXT.actions || "More actions"}
  <FiChevronRight className="rotate-90 text-gray-500 text-sm"/>
</button>

{actionsOpen && (
  <div className="
    actions-overlay
    absolute right-0 top-full mt-1
    w-40
    bg-white
    border border-gray-300
    rounded-xl
    shadow-[0_20px_40px_rgba(0,0,0,0.12)]
    z-50
  ">

    {/* EDIT */}
<button
  onClick={() => {
    setEditing(true);
    setActionsOpen(false);
  }}
  className="w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-gray-100"
>
  <FaEdit className="text-gray-900 text-[13px]" />
  {TEXT.edit}
</button>

<button
  onClick={() => {
    setResetPasswordOpen(true);
    setActionsOpen(false);
  }}
  className="w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-gray-100"
>
  <FaEdit className="text-gray-900 text-[13px]" />
  {TEXT.resetPassword}
</button>

{/* BLOCK / UNBLOCK */}
<button
  onClick={() => {
    toggleStatus();
    setActionsOpen(false);
  }}
  className="w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-gray-100"
>
  {customer.status === "active" ? (
    <FaUserSlash className="text-gray-900 text-[13px]" />
  ) : (
    <FaUserShield className="text-gray-900 text-[13px]" />
  )}
  {customer.status === "active" ? TEXT.block : TEXT.unblock}
</button>

{/* DIVIDER */}
<div className="border-t my-1"></div>

{/* DELETE */}
<button
  onClick={() => {
  setDeleteId(customer.id);
  setActionsOpen(false);
}}
  className="w-full flex items-center gap-2 px-3 py-2 text-sm text-red-600 hover:bg-red-50"
>
  <FaTrash className="text-red-600 text-[13px]" />
  {lang === "AR" ? "حذف" : "Delete"}
</button>

  </div>
)}

</div>


            </div>

<div className="
  bg-white
  border border-[#e3e3e3]
  rounded-[12px]
  shadow-[0_1px_0_rgba(0,0,0,0.04)]
  mb-4
">

<div
  className={`
    grid grid-cols-2 sm:grid-cols-3
    text-sm
    ${lang === "EN"
      ? "divide-x divide-gray-200"
      : "divide-x divide-gray-200 flex-row-reverse"}
  `}
>

  {/* AMOUNT SPENT */}
  <div className={`px-4 py-3 flex flex-col justify-center ${lang === "EN" ? "border-r" : "border-l"} border-gray-200`}>
    <span className="font-semibold text[15px] text-gray-900 mb-[2px]">
      {lang === "AR" ? "المبلغ المنفق" : "Amount spent"}
    </span>
    <span className="font-semibold text-gray-900 text-[13px]">
      {customer.totalSpent || "0.00"}$
    </span>
  </div>

  {/* ORDERS */}
  <div className={`px-4 py-3 flex flex-col justify-center ${lang === "EN" ? "border-r" : "border-l"} border-gray-200`}>
    <span className="font-semibold text[15px] text-gray-900 mb-[2px]">
      {TEXT.orders}
    </span>
    <span className="font-semibold text-gray-900 text-[13px]">
      {customer.ordersCount || 0}
    </span>
  </div>

  {/* CUSTOMER SINCE */}
  <div className="px-4 py-3 flex flex-col justify-center">
    <span className="font-semibold text[15px] text-gray-900 mb-[2px]">
      {lang === "AR" ? "عميل منذ" : "Customer since"}
    </span>
    <span className="font-semibold text-gray-900 text-[13px]">
      {formatSince(customer.createdAt)}
    </span>
  </div>


</div>
</div>

            {/* TOP CARDS */}
 <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_320px] gap-3 mb-4 items-start">

  {/* LEFT = LAST ORDER (same as checkout details) */}
  <div className="bg-white border border-[#e1e3e5] rounded-[18px] overflow-hidden">

    {/* HEADER */}
    <div className="flex items-center justify-between px-4 pt-4 mt-1">
      <h2 className="text-[13px] font-semibold text-[#202223]">
        {TEXT.lastOrderPlaced}
      </h2>

      <span className="text-[12px] text-[#6d7175] font-medium">
        {lastOrderDetails?.orderSource || TEXT.onlineStore}
      </span>
    </div>

    {/* CONTENT */}
  <div className="p-4 space-y-3 rounded-md border border-gray-200 m-3">

  {lastOrderDetails ? (
    <>
      {/* ================= ORDER INFO ROW ================= */}
      <div className="flex justify-between items-start">

        {/* LEFT SIDE */}
        <div className="flex flex-col gap-[2px]">

          {/* ORDER NUMBER + STATUS */}
          <div className="flex items-center gap-2 text-sm font-medium text-[#202223]">
            <span>#{lastOrderDetails.orderNumber}</span>

            {/* Payment status (mock if not present) */}
            <span
  className={`px-2 py-[2px] rounded-md text-[11px] font-medium ${getStatusBadge(lastOrderDetails.status)}`}
>
  {lastOrderDetails.status || "—"}
</span>
          </div>

          {/* DATE + SOURCE */}
          <div className="text-[12px] text-[#6d7175]">
            {new Date(lastOrderDetails.created_at).toLocaleDateString(
  lang === "AR" ? "ar-LB" : "en-US",
  {
              month: "long",
              day: "numeric",
              year: "numeric",
            })}{" "}
            {TEXT.at}{" "}
            {new Date(lastOrderDetails.created_at).toLocaleTimeString(
  lang === "AR" ? "ar-LB" : "en-US",
  {
              hour: "numeric",
              minute: "2-digit",
            })}{" "}
            {TEXT.from} {lastOrderDetails.orderSource || TEXT.onlineStore}
          </div>

        </div>

        {/* RIGHT SIDE (TOTAL) */}
        <div className="text-sm font-semibold text-[#202223]">
          ${lastOrderDetails.total.toFixed(2)}
        </div>

      </div>

      {/* ================= PRODUCTS ROW ================= */}
      <div className="border-t pt-3 space-y-2">

        {lastOrderDetails.items?.slice(0, 3).map((it, i) => (
          <div key={i} className="grid grid-cols-[minmax(0,1fr)_auto_auto] items-center gap-4">

  {/* LEFT */}
  <div className="flex items-center gap-3 min-w-0">
    <div className="w-10 h-10 rounded-md overflow-hidden border bg-[#f6f6f7]">
      <img src={it.image} className="w-full h-full object-cover" />
    </div>

    <div className="text-sm text-[#202223] truncate">
      {lang === "AR" ? it.title_ar : it.title_en}
    </div>
  </div>

  {/* QTY */}
  <span className="text-sm text-[#6d7175] text-center whitespace-nowrap">
    x {it.quantity}
  </span>

  {/* TOTAL */}
  <span className="text-sm font-medium text-[#202223] whitespace-nowrap">
    ${it.total.toFixed(2)}
  </span>

</div>
        ))}

      </div>

    </>
  ) : (
    <div className="flex flex-col items-center justify-center py-6 text-gray-400">
  <FaInbox className="text-xl mb-2 opacity-60" />
  <span className="text-sm">{TEXT.noOrders}</span>
</div>
  )}

</div>

    {/* ACTIONS */}
     <div className="px-4 py-3 flex justify-end gap-2">

      <button
        onClick={() => navigate(`/admin/orders?customer=${customer.id}`)}
        className="px-4 h-[34px] bg-white border border-gray-300 rounded-md text-sm shadow hover:bg-gray-50"
      >
        {TEXT.viewAllOrders}
      </button>

      <button
        onClick={() => navigate(`/admin/orders/add?customer=${customer.id}`)}
        className="px-4 h-[34px] bg-[#202223] text-white rounded-md text-sm hover:bg-black"
      >
        {TEXT.createOrder}
      </button>

    </div>

  </div>


  {/* RIGHT = CUSTOMER (EXACT abandoned cart style) */}
  <div className="bg-white border border-[#e1e3e5] rounded-[18px] overflow-hidden">

    <div className="p-4 space-y-4">

{/* NAME */}
{!editing ? (
  <>
    <div className="text-sm font-semibold text-[#202223]">
      {customer.name || "Guest"}
    </div>

    <div className="text-[12px] text-[#6d7175]">
      {customer.ordersCount || 0} {TEXT.orders}
    </div>
  </>
) : (
  <input
    value={form.name}
    onChange={(e)=>setForm({...form, name:e.target.value})}
    className="w-full border rounded px-2 py-1 text-sm"
  />
)}

{/* CONTACT */}
<div>
  <div className="text-[13px] font-semibold mb-1">
  {TEXT.contactInfo}
</div>

  {!editing ? (
    <>
      {customer.email && (
        <div className="text-sm text-[#1a73e8]">
          {customer.email}
        </div>
      )}

      <div className="text-sm">
        {customer.phone || "—"}
      </div>
    </>
  ) : (
    <div className="space-y-2">
      <input
        value={form.email}
        onChange={(e)=>setForm({...form, email:e.target.value})}
        className="w-full border rounded px-2 py-1 text-sm"
      />

      <input
        value={form.phone}
        onChange={(e)=>setForm({...form, phone:e.target.value})}
        className="w-full border rounded px-2 py-1 text-sm"
      />
    </div>
  )}
</div>

{/* WHOLESALE INFO */}
{(!editing && hasWholesaleInfo) && (
  <div>
    <div className="text-[13px] font-semibold mb-1">
      {TEXT.wholesaleInfo}
    </div>

    <div className="space-y-1 text-sm">
      {wholesaleInfo.businessName && (
        <div className="flex items-center gap-2">
          <FaStore className="text-gray-500 text-[12px]" />
          <span className="text-[#202223]">
            {wholesaleInfo.businessName}
          </span>
        </div>
      )}

      {wholesaleInfo.instagramName && (
        <div className="flex items-center gap-2">
          <FaInstagram className="text-gray-500 text-[12px]" />
          <span className="text-[#202223]">
            {wholesaleInfo.instagramName}
          </span>
        </div>
      )}

      {wholesaleInfo.instagramLink && (
        <a
          href={wholesaleInstagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm text-[#1a73e8] hover:underline"
        >
          <FaInstagram className="text-[12px]" />
          {TEXT.openInstagram}
        </a>
      )}
    </div>
  </div>
)}

{editing && (
  <div>
    <div className="text-[13px] font-semibold mb-1">
      {TEXT.wholesaleInfo}
    </div>

    <div className="space-y-2">
      <input
        placeholder={TEXT.businessName}
        value={form.businessName}
        onChange={(e) =>
          setForm({ ...form, businessName: e.target.value })
        }
        className="w-full border rounded px-2 py-1 text-sm"
      />

      <input
        placeholder={TEXT.instagramName}
        value={form.instagramName}
        onChange={(e) =>
          setForm({ ...form, instagramName: e.target.value })
        }
        className="w-full border rounded px-2 py-1 text-sm"
      />

      <input
        placeholder={TEXT.instagramLink}
        value={form.instagramLink}
        onChange={(e) =>
          setForm({ ...form, instagramLink: e.target.value })
        }
        className="w-full border rounded px-2 py-1 text-sm"
      />
    </div>
  </div>
)}

{/* ADDRESS */}
<div>
  <div className="text-[13px] font-semibold mb-1">
  {TEXT.defaultAddress}
</div>

  {!editing ? (
    <div className="text-sm leading-relaxed">
  {addressData.governorate || "—"}<br/>
  {addressData.area || "—"}<br/>
  {addressData.street || "—"}<br/>
  {addressData.building || "—"}
</div>
  ) : (
    <div className="space-y-2">
<div>
  <label className="block text-xs font-semibold text-[#6d7175] mb-2">
    {TEXT.country}
  </label>

  <select
    value={form.country}
    onChange={(e) =>
      setForm({
        ...form,
        country: e.target.value,
        city: "",
      })
    }
    className="w-full h-[40px] border border-[#c9cccf] rounded-[10px] px-3 text-sm bg-white"
  >
    <option value="Lebanon">
      {lang === "AR" ? "لبنان" : "Lebanon"}
    </option>
    <option value="Syria">
      {lang === "AR" ? "سوريا" : "Syria"}
    </option>
  </select>
</div>
      <div>
  <label className="block text-xs font-semibold text-[#6d7175] mb-2">
    {TEXT.governorate}
  </label>

  {form.country === "Lebanon" ? (
    <select
      value={form.city}
      onChange={(e) => setForm({ ...form, city: e.target.value })}
      className="w-full h-[40px] border border-[#c9cccf] rounded-[10px] px-3 text-sm bg-white"
    >
      <option value="">{TEXT.selectGovernorate}</option>
      {LEBANON_GOVERNORATES.map((g) => (
        <option key={g} value={g}>
          {g}
        </option>
      ))}
    </select>
  ) : (
    <input
      value={form.city}
      onChange={(e) => setForm({ ...form, city: e.target.value })}
      className="w-full h-[40px] border border-[#c9cccf] rounded-[10px] px-3 text-sm bg-white"
      placeholder={lang === "AR" ? "اكتب المحافظة" : "Enter governorate"}
    />
  )}
</div>
      <input
        placeholder={TEXT.area}
        value={form.area}
        onChange={(e)=>setForm({...form, area:e.target.value})}
        className="w-full border rounded px-2 py-1 text-sm"
      />
      <input
        placeholder={TEXT.street}
        value={form.street}
        onChange={(e)=>setForm({...form, street:e.target.value})}
        className="w-full border rounded px-2 py-1 text-sm"
      />
      <input
        placeholder="Building"
        value={form.building}
        onChange={(e)=>setForm({...form, building:e.target.value})}
        className="w-full border rounded px-2 py-1 text-sm"
      />
    </div>
  )}
</div>

      {/* MARKETING (simplified since no tracking here) */}
      <div className="mt-4">
        <div className="text-[13px] font-semibold text-[#202223] mb-2">
          {TEXT.marketing}
        </div>

        <div className="flex gap-2 flex-wrap">

  {/* EMAIL */}
  {customer.email && (
    <div className="
      flex items-center gap-1
      px-2.5 h-6
      rounded-md text-[11px] font-medium
      border bg-gray-100 text-gray-600 border-gray-200
    ">
      <span className="w-2 h-2 border border-gray-400 rounded-[3px]" />
      {TEXT.emailLabel}
    </div>
  )}

  {/* WHATSAPP */}
  {customer.phone && (
    <div className="
      flex items-center gap-1
      px-2.5 h-6
      rounded-md text-[11px] font-medium
      border bg-gray-100 text-gray-600 border-gray-200
    ">
      <span className="w-2 h-2 border border-gray-400 rounded-[3px]" />
      {TEXT.whatsappLabel}
    </div>
  )}

</div>
      </div>

      {/* STATUS */}
      <div className="mt-4">
        <span
          className={`px-3 py-1 rounded-full text-xs font-semibold ${
            customer.status === "active"
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
         {customer.status === "active"
  ? (lang === "AR" ? "نشط" : "Active")
  : (lang === "AR" ? "محظور" : "Blocked")}
        </span>
      </div>

    </div>

  </div>

</div>

       {/* ORDER HISTORY (TIMELINE STYLE - CLEAN) */}
<div className="mt-4">

  <h2 className="text-[15px] font-semibold text-[#202223] mb-5 px-1">
    {TEXT.orderHistory}
  </h2>

  {loading ? (
  <div className="space-y-3 animate-pulse">
    {[...Array(4)].map((_, i) => (
      <div key={i} className="h-4 bg-gray-200 rounded w-2/3"></div>
    ))}
  </div>
) : !customer.orders?.length ? (
    <div className="flex flex-col items-center py-8 text-gray-400">
  <FaInbox className="text-xl mb-2 opacity-60" />
  <span className="text-sm">{TEXT.noOrders}</span>
</div>
  ) : (
   <div
  className={`
    relative
    ${lang === "EN" ? "pl-8 text-left" : "pr-8 text-right"}
  `}
>

      {/* vertical line */}
      <div
  className={`
    absolute top-2 bottom-2 w-px bg-[#d9d9d9]
    ${lang === "EN" ? "left-[7px]" : "right-[7px]"}
  `}
/>

      {customer.orders.map((o) => {

        const realId = String(o.id).replace(/\D/g, "");

        const orderDate = new Date(o.date).toLocaleDateString(
          lang === "AR" ? "ar-LB" : "en-US",
          {
            year: "numeric",
            month: "short",
            day: "numeric",
          }
        );

        return (
          <div
            key={o.id}
            onClick={() => navigate(`/admin/orders/${realId}`)}
            className="relative mb-5 cursor-pointer group"
          >

            {/* DOT */}
            <span
  className={`
    absolute ${lang === "EN" ? "left-[-33px]" : "right-[-33px]"}
    top-[4px]
    w-[14px] h-[14px]
    bg-[#e5e5e5]
    rounded-[4px]
    flex items-center justify-center
  `}
>
  <span className="w-[6px] h-[6px] bg-[#202223] rounded-[2px]" />
</span>

            {/* CONTENT */}
            <div className="flex items-baseline justify-between gap-1.5">

              {/* LEFT TEXT */}
              <p className="text-[14px] text-[#202223] leading-6 group-hover:underline flex items-center flex-wrap gap-1.5">

                <span className="font-medium">
                  {customer.name}
                </span>{" "}

                {lang === "AR"
  ? "قام بإنشاء طلب رقم"
  : "placed an order"}{" "}

                <span className="font-medium">
                  #{o.orderNumber}
                </span>{" "}

                {lang === "AR"
  ? `بقيمة ${o.total}$`
  : `of $${o.total}`}{" "}

               <span
  className={`
    inline-flex items-center gap-1
    px-2 py-[2px]
    rounded-md border text-[11px] font-medium
    ${getOrderSourceBadge(o.orderSource)}
  `}
>
  {getOrderSourceIcon(o.orderSource)}
  {lang === "AR"
    ? getOrderSourceLabel(o.orderSource, "AR")
    : getOrderSourceLabel(o.orderSource, "EN")}
</span>

              </p>

              {/* RIGHT DATE */}
              <span className="text-[11px] text-gray-500 whitespace-nowrap ml-2">
                {orderDate}
              </span>

            </div>
          </div>
        );
      })}

    </div>
  )}
</div>

          </div>
          {editing && (
  <div className="
    block md:hidden
    fixed bottom-0 left-0 right-0
    bg-white border-t border-[#e1e3e5]
    px-5 py-3
    flex items-center justify-between gap-3
    z-40
  ">

    <span className="text-sm text-gray-600">
      {lang === "AR" ? "تعديل بيانات العميل" : "Editing customer"}
    </span>

    <div className="flex gap-2">

      {/* CANCEL */}
      <button
        onClick={() => {
  const parts = (customer.address || "").split(" — ");

setForm({
  name: customer.name || "",
  phone: customer.phone || "",
  email: customer.email || "",
  country: customer.addressCountry || "Lebanon",
  city: parts[0] || "",
    area: parts[1] || "",
    street: parts[2] || "",
    building: parts[3] || "",
  });

  setErrors({});
  setEditing(false);
  setIsDirty(false);
}}
        className="
          h-9 px-4
          border border-[#c9cccf]
          rounded-lg
          text-sm font-medium
          bg-white
          hover:bg-[#f6f6f7]
        "
      >
        {TEXT.cancel}
      </button>

      {/* SAVE */}
      <button
        onClick={() => setShowConfirmSave(true)}
        className="
          h-9 px-4
          bg-[#202223]
          text-white
          rounded-lg
          text-sm font-medium
          hover:bg-black
        "
      >
        {TEXT.save}
      </button>

    </div>
  </div>
)}

{showConfirmSave && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div className="w-[380px] bg-white rounded-[14px] shadow-xl overflow-hidden">

      <div className="px-5 py-4 border-b bg-[#f6f6f7]">
        <h2 className="text-[15px] font-semibold text-[#202223]">
          {lang === "AR" ? "تأكيد حفظ التعديلات؟" : "Save changes?"}
        </h2>
      </div>

      <div className="px-5 py-5 text-sm text-gray-600">
        {lang === "AR"
          ? "هل أنت متأكد أنك تريد حفظ تعديلات العميل؟"
          : "Are you sure you want to save the customer changes?"}
      </div>

      <div className="px-5 py-4 border-t bg-[#f6f6f7] flex justify-end gap-3">
        <button
          onClick={() => setShowConfirmSave(false)}
          className="h-[36px] px-4 border border-[#c9cccf] rounded-lg bg-white text-sm hover:bg-gray-50"
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>

        <button
          onClick={handleSave}
          className="h-[36px] px-4 bg-[#202223] text-white rounded-lg text-sm hover:bg-black"
        >
          {lang === "AR" ? "تأكيد" : "Confirm"}
        </button>
      </div>
    </div>
  </div>
)}

{resetPasswordOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div className="w-[380px] bg-white rounded-[14px] shadow-xl overflow-hidden">

      <div className="px-5 py-4 border-b bg-[#f6f6f7]">
        <h2 className="text-[15px] font-semibold text-[#202223]">
          {TEXT.resetPassword}
        </h2>
      </div>

      <div className="px-5 py-5">
        <label className="text-xs font-semibold text-[#6d7175] mb-2 block">
          {TEXT.newPassword}
        </label>

        <div className="relative">
  <input
    type={showResetPassword ? "text" : "password"}
    name="etika-reset-customer-passcode"
    autoComplete="new-password"
    value={newPassword}
    onChange={(e) => setNewPassword(e.target.value)}
    className={`
      w-full h-[40px]
      border border-[#c9cccf]
      rounded-[10px]
      px-3
      ${lang === "AR" ? "pl-10" : "pr-10"}
      text-sm
      bg-white
      focus:outline-none
      focus:ring-2 focus:ring-[#d9d9d9]
    `}
  />

  <button
    type="button"
    onClick={() => setShowResetPassword((v) => !v)}
    className={`
      absolute top-1/2 -translate-y-1/2
      ${lang === "AR" ? "left-3" : "right-3"}
      text-gray-500 hover:text-black
    `}
  >
    {showResetPassword ? <FaEyeSlash /> : <FaEye />}
  </button>
</div>
      </div>

      <div className="px-5 py-4 border-t bg-[#f6f6f7] flex justify-end gap-3">
        <button
          onClick={() => {
  setResetPasswordOpen(false);
  setNewPassword("");
  setShowResetPassword(false);
}}
          className="h-[36px] px-4 border border-[#c9cccf] rounded-lg bg-white text-sm hover:bg-gray-50"
        >
          {TEXT.cancel}
        </button>

        <button
          onClick={handleResetPassword}
          className="h-[36px] px-4 bg-[#202223] text-white rounded-lg text-sm hover:bg-black"
        >
          {TEXT.save}
        </button>
      </div>
    </div>
  </div>
)}

{deleteId && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">

    <div className="w-[380px] bg-white rounded-[14px] shadow-xl overflow-hidden">

      <div className="px-5 py-4 border-b bg-[#f6f6f7] flex items-center gap-3">
        <div className="w-9 h-9 flex items-center justify-center rounded-full bg-red-50 border">
          <FaUserSlash className="text-red-600 text-sm"/>
        </div>

        <h2 className="text-[15px] font-semibold">
          {lang === "AR" ? "حذف العميل؟" : "Delete customer?"}
        </h2>
      </div>

      <div className="px-5 py-5 text-sm text-gray-600">
        {lang === "AR"
          ? "لا يمكن التراجع عن هذا الإجراء."
          : "This action cannot be undone."}
      </div>

      <div className="px-5 py-4 border-t flex justify-end gap-3 bg-[#f6f6f7]">

        <button
          onClick={() => setDeleteId(null)}
          className="h-[36px] px-4 border rounded-lg bg-white"
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>

        <button
          onClick={confirmDelete}
          className="h-[36px] px-4 bg-red-600 text-white rounded-lg"
        >
          {lang === "AR" ? "حذف" : "Delete"}
        </button>

      </div>
    </div>
  </div>
)}

{toast && (
  <div className="fixed bottom-6 right-6 z-[9999] animate-fadeSlide">
    <div className="flex items-center gap-3 px-4 py-3 bg-[#202223] text-white rounded-lg shadow text-sm font-medium">
      <div className="w-5 h-5 flex items-center justify-center rounded-full bg-white/20 text-xs">
        ✓
      </div>
      <span>{toast.message}</span>
    </div>
  </div>
)}

{isSaving && (
  <div className="fixed inset-0 bg-white/60 backdrop-blur-[1px] z-40 flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-black border-t-transparent rounded-full animate-spin"></div>
  </div>
)}
        </main>
      </div>
    </div>
  );
}

export default AdminCustomerProfile;
